import React, { useEffect, useRef, useState } from "react";
import { Button, Checkbox, Form, Input } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import "./Login.scss";
import { BASE_API_URL } from "../../utils/consts";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setUserData } from "../../utils/redux/slices/userDataSlice";
import { ReactComponent as LogoIcon } from "../../assets/fixmanLogo.svg";
import { setLoader } from "../../utils/redux/slices/loaderSlice";
type FieldType = {
  email?: string;
  password?: string;
  remember?: string;
};

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const form: any = useRef(null);
  const [error, setError] = useState<any>(undefined);
  const [activeAccount, setActivateAccount] = useState<any>(undefined);
  const [forgotPassword, setForgotPassword] = useState<any>(false);
  const onFinish = (values: any) => {
    dispatch(setLoader(true));
    axios
      .post(`${BASE_API_URL}/auth/signin`, {
        email: values.email,
        password: values.password,
      })
      .then(function (response) {
        // handle success
        navigate("/appointments");
        dispatch(setUserData(response.data));
        localStorage.setItem("user", JSON.stringify(response.data));
      })
      .catch(function (error) {
        console.log("error", error);
        setError(error.response.data.message);
        // handle error
        console.error(error);
      })
      .finally(function () {
        dispatch(setLoader(false));
      });
  };

  useEffect(() => {
    form?.current?.getFieldInstance("email").focus();
  }, []);

  const onFinishFailed = (errorInfo: any) => {
    console.error("Failed:", errorInfo);
  };

  const onFinishForgotPassword = (values: any) => {
    console.log("values", values);
    axios
      .post(
        `https://fixman-hr-node-deploy-db4ade5f8887.herokuapp.com/forgot-password`,
        {
          email: values.email,
        }
      )
      .then((res) => console.log("res", res));
  };
  const onFinishFailedForgotPassword = (errorInfo: any) => {
    console.error("Failed:", errorInfo);
  };

  console.log("error", error);

  const reactivateAccount = (email: any) => {
    axios
      .post(`${BASE_API_URL}/activateAccount`, {
        email: email,
      })
      .then(function (response) {
        // handle success
        setActivateAccount(response.data);
        console.log("res", response);
      })
      .catch(function (error) {
        console.log("error", error);
        setError(error.response.data.message);
        // handle error
        console.error(error);
      })
      .finally(function () {
        dispatch(setLoader(false));
      });
  };
  console.log("activeAccount", activeAccount);
  return (
    <div className="loginPage">
      <div className="loginImageBg hide-md"></div>
      <div className="login">
        <div className="loginHeader">
          <LogoIcon />
        </div>
        <div className="formContainer">
          {!forgotPassword ? (
            <Form
              name="basic"
              ref={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              style={{ width: "100%" }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item<FieldType>
                name="email"
                label={t("Email")}
                rules={[
                  { required: true, message: t("Please input your email!") },
                ]}
              >
                <Input placeholder={t("Email")} />
              </Form.Item>

              <Form.Item<FieldType>
                name="password"
                className="loginPassword"
                label={t("Password")}
                rules={[
                  { required: true, message: t("Please input your password!") },
                ]}
              >
                <Input.Password placeholder={t("Password")} />
              </Form.Item>

              {/* <Form.Item<FieldType>
            name="remember"
            valuePropName="checked"
            wrapperCol={{ offset: 8, span: 16 }}
          >
            <Checkbox>Remember me</Checkbox>
          </Form.Item> */}
              {error && (
                <div className="errorLogin">
                  {!activeAccount?.message ? <p>{t(`${error}`)}</p> : undefined}
                  <p>{activeAccount ? t(`${activeAccount?.message}`) : ""}</p>

                  {error.includes("User account is not activated.") && (
                    <div
                      className="emailActivationLink"
                      onClick={() => {
                        const email = form.current?.getFieldValue("email");
                        if (email) {
                          reactivateAccount(email);
                        } else {
                          setError(
                            "Please enter your email before requesting reactivation."
                          );
                        }
                      }}
                    >
                      Activate
                    </div>
                  )}
                </div>
              )}
              <Form.Item wrapperCol={{ span: 16 }}>
                <Button type="primary" htmlType="submit">
                  {t("Log In")}
                </Button>
              </Form.Item>
            </Form>
          ) : (
            <>
              <span
                className="backToLogin"
                onClick={() => setForgotPassword(false)}
              >
                Back to Login
              </span>
              <Form
                name="forgot-password"
                ref={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ width: "100%" }}
                initialValues={{ remember: true }}
                onFinish={onFinishForgotPassword}
                onFinishFailed={onFinishFailedForgotPassword}
                autoComplete="off"
              >
                <Form.Item<FieldType>
                  name="email"
                  label={t("Email")}
                  rules={[
                    { required: true, message: t("Please input your email!") },
                  ]}
                >
                  <Input placeholder={t("Email")} />
                </Form.Item>
                <Form.Item wrapperCol={{ span: 16 }}>
                  <Button type="primary" htmlType="submit">
                    {t("Submit")}
                  </Button>
                </Form.Item>
              </Form>
            </>
          )}
          <div
            className="forgotPassword"
            onClick={() => setForgotPassword(true)}
          >
            {t("Forgot password")}
          </div>
        </div>
        {/* <div className="footerLogin">footer</div> */}
      </div>
    </div>
  );
};

export default Login;
